import React from 'react';
import {Breadcrumbs, FlexColumn, FlexContainer, FlexItem, FlexRow, Heading, Text} from '@forecast-it/design-system';
import {getDefaultMediumClientLogo} from '../../../components/default_avatars';
import Styled from 'styled-components';
import {FormattedMessage} from 'react-intl';
import {Link} from 'react-router-dom';
import SettingsClientsSubNav from './SettingsClientsSubNav';
import {clientLogoSrc} from '../../../directApi';
import {hasFeatureFlag} from '../../shared/util/FeatureUtil';
import {FEATURE_FLAGS} from '../../../constants';

const BreadcrumbsWrapper = Styled.div`
  	padding-bottom: 24px;
`;

interface SettingsClientHeaderProps {
	clientId: string;
	clientName?: string | null | undefined;
	clientLogoId?: string | null;
	clientLogoDefaultId: number | null;
}

const SettingsClientHeader = ({
	clientId,
	clientName,
	clientLogoId,
	clientLogoDefaultId,
}: SettingsClientHeaderProps): JSX.Element => {
	const logoSrc = clientLogoId ? clientLogoSrc(clientLogoId) : getDefaultMediumClientLogo(clientLogoDefaultId);
	const clientsListPath = hasFeatureFlag(FEATURE_FLAGS.NEW_CLIENTS_FEATURE) ? '/clients' : '/admin/clients';

	return (
		<>
			<BreadcrumbsWrapper>
				<Breadcrumbs>
					<Breadcrumbs.Item>
						<Link to={clientsListPath}>
							<FormattedMessage id="common.all_clients" />
						</Link>
					</Breadcrumbs.Item>
					<Breadcrumbs.Item>
						<span>{clientName || ''}</span>
					</Breadcrumbs.Item>
				</Breadcrumbs>
			</BreadcrumbsWrapper>

			<FlexContainer>
				<FlexRow gap={'xl'}>
					<FlexItem>
						<img crossOrigin="use-credentials" alt="client-logo" src={logoSrc} width="96" height="96" />
					</FlexItem>
					<FlexColumn alignItems={'flex-start'} alignSelf={'center'} gap={'s'}>
						<Text>
							<FormattedMessage id="common.client" />
						</Text>
						<Heading size={3}>{clientName || '-'}</Heading>
					</FlexColumn>
				</FlexRow>
			</FlexContainer>

			<SettingsClientsSubNav clientId={clientId} />
		</>
	);
};

export default SettingsClientHeader;
